import { render, staticRenderFns } from "./physical-results.vue?vue&type=template&id=f630e1ac&scoped=true"
import script from "./physical-results.vue?vue&type=script&lang=ts"
export * from "./physical-results.vue?vue&type=script&lang=ts"
import style0 from "./physical-results.vue?vue&type=style&index=0&id=f630e1ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f630e1ac",
  null
  
)

export default component.exports